import { BoardBarList } from '../../../boardui/BarList'
import { CreatorAvatar } from './RankList'
import { barWidth } from './bars'

// Height of one row, in pixels, at the default card size, so a list can be
// fitted to its widget: it holds a 24px avatar. A bigger card scales it up
// to the max (useFittedRows), and the rows then share the box exactly; it
// never depends on what a row contains.
export const BAR_ROW_HEIGHT = 36
export const BAR_ROW_MAX_HEIGHT = 48

// Studio owns the data contract; BoardUI owns the overlaid bar presentation.
// Keep the supplied order, per-item currency formatting and original item
// callbacks, plus CreatorAvatar's existing image fallback and fitted sizing.
export function BarList({ items, format = (value) => String(value), series = '1', label, onSelect, rowHeight = BAR_ROW_HEIGHT }) {
  const max = Math.max(...items.map((item) => item.value), 0) || 1
  const rows = items.map((item) => ({
    key: item.key || item.label,
    label: item.label,
    value: format(item.value, item),
    width: barWidth(item.value, max),
    icon: item.avatar ? <CreatorAvatar name={item.avatar.name} src={item.avatar.src} /> : null,
    onSelect: onSelect ? () => onSelect(item) : undefined,
  }))
  return <BoardBarList items={rows} label={label} series={series} rowHeight={rowHeight} />
}
